<template>
    <div class="chatgpt-wrap-area">
        <div class="container-fluid">
            <v-row>
                <v-col md="3" cols="12">
                    <div style="height: 100%;">
                    <div class="event-details-wrap-area">
                        <div class="event-name-wrap">
                            <h2>Untitled Event</h2>
                        </div>
                        <div class="event-date"><p>Date: <span>20/04/2023</span></p></div>
                        
                        <v-btn @click="openLeftPanel=true" elevation="0" class="event-list-open"><img src= "../../assets/Images/chatgpt/switch-event.svg"/><span class="switchevent-txt">Switch Event</span></v-btn>
                    </div>
                    <div v-if="!isMobileView || sampleChatPanel" class="sample-chat-area">
                        <div class="sample-chat-head">
                            <p class="ico-bulb">Don't stray toofar from the samples. I'm still learning.</p>
                            <v-btn @click="sampleChatPanel=false" fab text small><v-icon size="22px" color="#4d89eb">mdi-close</v-icon></v-btn>
                        </div>
                        <div class="sample-chat-list">
                            <ul>
                                <li><p>Name and theme of your conference</p></li>
                                <li><p>Date and time of the conference</p></li>
                                <li><p>It will be in-person, virtual, or hybrid</p></li>
                                <li><p>What is the location of your conference</p></li>
                                <li><p>Who are the keynote speakers or special guests you would like to feature at your conference?</p></li>
                               <li><p>What are the topics or sessions you would like to include in your conference program?</p></li>

                                <li><p>Name and theme of your conference</p></li>
                                <li><p>Date and time of the conference</p></li>
                                <li><p>It will be in-person, virtual, or hybrid</p></li>
                                <li><p>What is the location of your conference</p></li>
                                <li><p>Who are the keynote speakers or special guests you would like to feature at your conference?</p></li>
                                <li><p>What are the topics or sessions you would like to include in your conference program?</p></li>
                            </ul>
                        </div>
                    </div>
                    </div>
                </v-col>
                <v-col md="8" cols="12">
                    <div class="chatgpt-screen-area">
                        <div class="chat-screen">
                            <!-- <div class="welcome-screen">
                                <img src="../../assets/Images/chatgpt/huddle-icon.png"/>
                                <h4>e2m.live - Huddl Powered by GPT<br/>Create events in a jiffy</h4>
                            </div> -->
                            <ChatGptSender/>
                        </div>
                        <div class="msg-screen">
                            <div class="msg-type">
                                <v-btn @click="sampleChatPanel= true" elevation="0" small class="open-prompt-suggestion"><img src="../../assets/Images/chatgpt/prompt-suggestion.svg"/></v-btn>
                                <input type="text" name="" id="" value="" placeholder="Type Here..."/>
                                <v-btn @click="OpenVoiceBox=true" elevation="0" class="send-msg-btn">
                                    <v-icon color="#1a73e8" size="35px">mdi-microphone-outline</v-icon>
                                </v-btn>
                                <v-btn elevation="0" class="send-msg-btn">
                                    <img src="../../assets/Images/chatgpt/send-button.png"/>
                                </v-btn>
                            </div>
                        </div>
                    </div>                    
                </v-col>
                <v-col md="1" cols="12">
                    <div class="chatgpt-right-pannel">
                        <div class="right-cht-options-top">
                            <div class="right-chat-single-option">
                                <v-btn @click="PromptLibraryOpen=true" elevation="0" class="chat-action-button">
                                    <img src="../../assets/Images/chatgpt/prompt-library.svg"/>
                                    Prompt<br/>Library
                                </v-btn>
                            </div>
                            <div class="right-chat-single-option">
                                <v-btn elevation="0" class="chat-action-button">
                                    <img src="../../assets/Images/chatgpt/preview.svg"/>
                                    Preview
                                </v-btn>
                            </div>
                            <div class="right-chat-single-option">
                                <v-btn elevation="0" class="chat-action-button">
                                    <img src="../../assets/Images/chatgpt/edit-in-cms.svg"/>
                                    Edit in CMS
                                </v-btn>
                            </div>
                            <div class="right-chat-single-option">
                                <v-btn elevation="0" class="chat-action-button">
                                    <img src="../../assets/Images/chatgpt/help.svg"/>
                                    Help
                                </v-btn>
                            </div>
                        </div>
                        <div class="right-cht-options-bottom">
                            <div class="right-chat-single-option">
                                <v-btn elevation="0" class="chat-action-button">
                                    <img src="../../assets/Images/chatgpt/logout.svg"/>
                                    Exit
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
        <ChatGptEventListLeft v-if = "openLeftPanel==true"/>
        <GptPromptLibrary v-if = "PromptLibraryOpen==true"/>
        <GptVoicePanel v-if = "OpenVoiceBox==true"/>
    </div>
</template>
<script>
import ChatGptEventListLeft from "@/components/ChatGptEventListLeft";
import GptPromptLibrary from "@/components/GptPromptLibrary";
import ChatGptSender from "@/components/ChatGptSender";
import GptVoicePanel from "@/components/GptVoicePanel";
export default {
    components: {
        ChatGptEventListLeft,
        GptPromptLibrary,
        ChatGptSender,
        GptVoicePanel,
    },
    data() {
        return {
            openLeftPanel: false,
            PromptLibraryOpen: false,
            OpenVoiceBox: false,
            sampleChatPanel: false,
            isMobileView: false,
            ShowDesktop: true,
            
        }
        
    },
    computed: {
        
    },
    watch: {},
    created() {},
    mounted() {
        this.isMobileView = this.isMobileOrIPad();
    },
    methods: {
        closeBrandingPanel(){
            this.$parent.brandingDrawer = false; 
        }
    },
    
}

</script>